<div class="saml-validate-container">
  @if (isLoading) {
    <div class="loading-spinner">
      <div class="spinner"></div>
      <p>Validating your SSO login...</p>
    </div>
  }

  @if (errorMessage) {
    <div class="error-message">
      <p>{{ errorMessage }}</p>
    </div>
  }
</div>
